import { Box, Center, Grid, Spinner, Text, VStack } from '@chakra-ui/react';
import { TransactionNotificationLogFragment } from '@client/graphql/__generated__/types';
import { FC } from 'react';
import { NotificationRow } from './NotificationRow';

interface NotificationsTableProps {
  notifications: TransactionNotificationLogFragment[];
  loading: boolean;
  triggerRef: (ref: HTMLDivElement | null) => void;
  onViewDetails: (notification: TransactionNotificationLogFragment) => void;
}

const TableHeader: FC = () => (
  <Grid
    borderBottom="1px solid"
    borderColor="whiteAlpha.100"
    gap={5}
    gridTemplateColumns="1fr 1fr 1fr 1fr 1fr 160px"
    pb={3.5}
    pt={4}
    px={5}
  >
    <Text
      color="whiteAlpha.600"
      fontSize="xs"
      fontWeight="medium"
      letterSpacing="wider"
      textTransform="uppercase"
    >
      Title
    </Text>
    <Text
      color="whiteAlpha.600"
      fontSize="xs"
      fontWeight="medium"
      letterSpacing="wider"
      textTransform="uppercase"
    >
      Recipient(s)
    </Text>
    <Text
      color="whiteAlpha.600"
      fontSize="xs"
      fontWeight="medium"
      letterSpacing="wider"
      textTransform="uppercase"
    >
      Event
    </Text>
    <Text
      color="whiteAlpha.600"
      fontSize="xs"
      fontWeight="medium"
      letterSpacing="wider"
      textTransform="uppercase"
    >
      Type
    </Text>
    <Text
      color="whiteAlpha.600"
      fontSize="xs"
      fontWeight="medium"
      letterSpacing="wider"
      textTransform="uppercase"
    >
      Message
    </Text>
    <Text
      color="whiteAlpha.600"
      fontSize="xs"
      fontWeight="medium"
      letterSpacing="wider"
      textTransform="uppercase"
    >
      Date
    </Text>
  </Grid>
);

export const NotificationsTable: FC<NotificationsTableProps> = ({
  notifications,
  loading,
  triggerRef,
  onViewDetails,
}) => {
  if (!loading && notifications.length === 0) {
    return (
      <Center py={16}>
        <VStack spacing={2}>
          <Text color="whiteAlpha.600" fontSize="lg">
            No notifications found
          </Text>
          <Text color="whiteAlpha.400" fontSize="sm">
            Sent notifications will appear here
          </Text>
        </VStack>
      </Center>
    );
  }

  return (
    <Box
      bg="whiteAlpha.50"
      border="1px solid"
      borderColor="whiteAlpha.100"
      borderRadius="lg"
      mx={{ base: 0, md: 6, lg: 10 }}
      overflow="hidden"
    >
      <TableHeader />

      {notifications.map((notification) => (
        <NotificationRow
          key={notification.id}
          notification={notification}
          onViewDetails={() => onViewDetails(notification)}
        />
      ))}

      {/* Infinite scroll trigger */}
      <Box ref={triggerRef} h={1} />

      {loading && (
        <Center py={4}>
          <Spinner color="whiteAlpha.600" size="sm" />
        </Center>
      )}
    </Box>
  );
};
